import {ModalController} from '@ionic/angular';
import {Component, Input, OnInit, ViewChild} from '@angular/core';

import {DataTableOptions, TableService} from '@services';
import { DataTableComponent, ITab } from '@shared/components';
import { FolderPanelSelectionType, IFolder, IPanelButton, IPanelConfig } from '@modules/management/modules/folders/model/folders.interfaces';

import {TranslateService} from '@ngx-translate/core';
import { each, filter, map, orderBy } from 'lodash';

@Component({
  selector: 'app-folder-search-modal',
  templateUrl: './folder-search-modal.component.html',
  styleUrls: ['./folder-search-modal.component.scss'],
})
export class FolderSearchModalComponent implements OnInit {
  @Input() dataTableOptions: DataTableOptions;
  @Input() foldersList: IFolder[];
  @Input() folderUrl: string;
  @Input() tabTitle: string;
  @Input() panelConfig: IPanelConfig;
  @Input() setSelection: (ids: number[], type: FolderPanelSelectionType | null) => void;

  @ViewChild('testTableID') folderItemComponent;
  @ViewChild(DataTableComponent) dataTableComponent: DataTableComponent;

  public filteredFoldersList: IFolder[] = [];
  public tableRecordsDisplay = 0;
  public searching = false;

  public tabs: ITab[] = [
    {
      key: 'items',
      value: `${this.translate.instant('SHARED.Items')}`,
      postfix: '(0)',
    },
    {
      key: 'folders',
      value: `${this.translate.instant('SHARED.Folders')}`,
      postfix: '(0)',
    }
  ];
  public currentTab: ITab = this.tabs[0];
  public searchWord = '';

  constructor(
    private translate: TranslateService,
    private modalController: ModalController,
    private tableService: TableService
  ) {}

  ngOnInit() {
    const onRowClickedHandler = this.dataTableOptions.onRowClicked.bind(this);
    const onRowSelectedHandler = this.dataTableOptions.onRowSelected.bind(this);

    this.dataTableOptions.onRowClicked = (...parameters) => {
      if (this.panelConfig?.selectedIds?.length) {
        return;
      }
      this.modalController.dismiss();
      onRowClickedHandler(...parameters);
    };

    this.dataTableOptions.onRowSelected = (...parameters) => {
      const [, selectedIds = []] = parameters;

      if (selectedIds.length) {
        this.clearFolderSelection();
      }

      onRowSelectedHandler?.(...parameters);
    };
  }

  public onChangeTab(tab: ITab): void {
    this.currentTab = tab;
  }

  public onCloseModal() {
    this.modalController.dismiss();
  }

  public onFolderRowClick(): void {
    if (this.panelConfig?.selectedIds?.length) {
      return;
    }
    this.onCloseModal();
  }

  public customSearch(): void {
    this.searching = true;
    const tableSelector = `#${this.dataTableComponent.tableId}`;
    const mainTable = this.dataTableComponent.getTable();

    if (this.searchWord.length) {
      if ($(`${tableSelector} thead`).length && mainTable.page.info().recordsTotal) {
        mainTable.search(this.searchWord).draw(false);
        this.tableRecordsDisplay = mainTable.page?.info()?.recordsDisplay;
        this.tableService.highlightSearchResult(tableSelector, this.searchWord);

        setTimeout(() => {
          mainTable.draw(false).columns.adjust();
        });
      }

      this.filteredFoldersList = orderBy(filter(
        this.foldersList, (item: IFolder) => (item.title?.toUpperCase() ?? '').indexOf(this.searchWord.toUpperCase()) > -1), [folder => folder.title?.toLowerCase() ?? ''], ['asc']);
    } else {
      this.filteredFoldersList = [];
      this.tableRecordsDisplay = 0;
      this.searching = false;
    }

    this.tabs[0].postfix = `(${this.tableRecordsDisplay})`;
    this.tabs[1].postfix = `(${this.filteredFoldersList.length})`;
  }

  public showEmptyMsg(tabKey: string): boolean {
    return !this.searchWord.length && !this.searching ||
      this.searchWord.length && (tabKey === 'items' && !this.tableRecordsDisplay || tabKey === 'folders' && !this.filteredFoldersList.length)
  }

  public onFolderSelect(): void {
    const selectedIds = map(filter(this.foldersList || [], 'selected'), 'folderID');

    this.clearItemSelection();
    this.setSelection?.(selectedIds, selectedIds.length ? FolderPanelSelectionType.Folders : null);
  }

  public async onActionClicked(actionButton: IPanelButton) {
    await actionButton.action();

    if (!this.panelConfig?.selectedIds?.length) {
      this.clearFolderSelection();
      this.clearItemSelection();
      this.dataTableComponent.render();
      this.customSearch();
    }
  }

  private clearFolderSelection(): void {
    each(this.foldersList || [], (folder: IFolder) => {
      folder.selected = false;
    });
  }

  private clearItemSelection(): void {
    const table = this.dataTableComponent?.getTable();

    if (table?.rows({selected: true})?.count()) {
      (table as any).rows().deselect();
    }
  }
}
